/**
 * Socket.IO event name constants — single source of truth for client and
 * server. Use the `SocketEvent` union type when typing event names in code so
 * a typo becomes a compile error.
 */
export const SocketEvents = {
    // Client → Server
    PLAYER_MOVE: 'player:move',
    BATTLE_ACTION: 'battle:action',
    PVP_CHALLENGE: 'pvp:challenge',
    /**
     * Client → Server. Asks the server to re-emit `world:state` to this socket.
     * Used by OverworldScene at scene-create time to handle the race where the
     * initial `world:state` was emitted by the server during BootScene's asset
     * preload phase (before any listener was bound).
     */
    WORLD_REQUEST: 'world:request',
    // Server → Client
    WORLD_STATE: 'world:state',
    PLAYER_JOINED: 'player:joined',
    PLAYER_LEFT: 'player:left',
    PLAYER_MOVED: 'player:moved',
    ENCOUNTER_START: 'encounter:start',
    BATTLE_START: 'battle:start',
    BATTLE_UPDATE: 'battle:update',
    BATTLE_END: 'battle:end',
    CREATURE_LEVELUP: 'creature:levelup',
    /** Deferred per FR-011 — emitted only after evolution lands. */
    CREATURE_EVOLVED: 'creature:evolved',
    BATTLE_WAITING: 'battle:waiting',
    BATTLE_FORCESWITCH: 'battle:forceswitch',
    /**
     * Server → Client. Emitted to a socket whose player just stepped on a
     * healing tile and had their party fully restored. Carries the new party
     * snapshot so the client can refresh any HP UI it shows.
     */
    BATTLE_HEALED: 'battle:healed',
    PVP_DISCONNECTED: 'pvp:disconnected',
    /**
     * Server → Client. Emitted to an old socket immediately before the server
     * force-disconnects it because a newer socket has authenticated as the same
     * playerId. See solution.md "Connection Lifecycle > Multi-socket policy".
     */
    SESSION_TERMINATED: 'session:terminated',
    ERROR: 'error',
};
//# sourceMappingURL=events.js.map